import { beliefs } from "../mock";
import { ChevronRight, BookOpen } from "lucide-react";

export default function BeliefsPreview() {
  const featured = beliefs.slice(0, 6);
  return (
    <section className="py-24 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <div className="text-[#c8a36a] uppercase tracking-[0.32em] text-xs font-bold mb-3">Statement of Faith</div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0a2d38] tracking-tight">The 16 Truths We Hold</h2>
          <p className="mt-5 text-[#4a5b62] max-w-2xl mx-auto leading-relaxed">
            Rooted in the Word, alive in the Spirit. Here are some of the foundational truths that guide our church family.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((b) => (
            <div key={b.n} className="bg-[#f5f7f9] hover:bg-white border border-[#e8ecef] hover:border-[#c8a36a] rounded-md p-7 card-lift relative overflow-hidden transition-colors">
              <div className="absolute -top-2 -right-2 text-[88px] font-bold leading-none text-[#e8ecef] select-none">{b.n}</div>
              <div className="relative">
                <div className="flex items-center gap-2 text-[#c8a36a] text-xs uppercase tracking-[0.28em] font-bold">
                  <BookOpen className="h-3.5 w-3.5" /> Truth {b.n}
                </div>
                <h3 className="mt-3 text-xl font-bold text-[#0a2d38] leading-snug">{b.title}</h3>
                <p className="mt-3 text-[15px] text-[#4a5b62] leading-relaxed">{b.short}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a href="/what-we-believe" className="btn-teal rounded-full px-7 py-3 inline-flex items-center gap-2">
            Read All 16 Fundamental Truths <ChevronRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
